import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Col,
  Card,
  Button,
  ListGroup,
  Image,
  Offcanvas,
} from "react-bootstrap";

import logo from "../../assets/images/dashboard-logo.PNG";
import points from "../../assets/images/Earn Points.svg";

// Shared sidebar menu config
const menuItems = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="nav-icon" width="15" height="15" viewBox="0 0 48.06 48.059">
        <path d="M213.612,513.81a6.868,6.868,0,0,0-6.866,6.866v6.865a6.868,6.868,0,0,0,6.866,6.866h6.866a6.868,6.868,0,0,0,6.865-6.866v-6.865a6.868,6.868,0,0,0-6.865-6.866Zm0,27.463a6.868,6.868,0,0,0-6.866,6.865V555a6.868,6.868,0,0,0,6.866,6.865h6.866A6.868,6.868,0,0,0,227.343,555v-6.866a6.868,6.868,0,0,0-6.865-6.865Zm20.6-20.6a6.868,6.868,0,0,1,6.866-6.866h6.865a6.868,6.868,0,0,1,6.866,6.866v6.865a6.868,6.868,0,0,1-6.866,6.866h-6.865a6.868,6.868,0,0,1-6.866-6.866Zm0,27.462a6.868,6.868,0,0,1,6.866-6.865h6.865a6.868,6.868,0,0,1,6.866,6.865V555a6.868,6.868,0,0,1-6.866,6.865h-6.865A6.868,6.868,0,0,1,234.209,555Z" transform="translate(-206.746 -513.81)" fill="#029c27" />
      </svg>
    ),
  },
  {
    label: "Profile",
    path: "/profile",
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="nav-icon" width="15" height="15" viewBox="0 0 40.298 40.298">
                                    <g id="Profile" transform="translate(-208.516 -1757.116)">
                                        <path id="Path_681" data-name="Path 681" d="M27.518,380.656c0,2.9-2.783,5.228-6.1,4.971a5.576,5.576,0,0,1-5.1-5.23v-1.478a5.576,5.576,0,0,1,5.1-5.23c3.318-.257,6.1,2.068,6.1,4.971Z" transform="translate(206.746 1392.095)" fill="none" stroke="#029c27" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.5" />
                                        <circle id="Ellipse_1090" data-name="Ellipse 1090" cx="18.399" cy="18.399" r="18.399" transform="translate(210.266 1758.866)" fill="none" stroke="#029c27" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.5" />
                                        <path id="Path_682" data-name="Path 682" d="M9.375,398.625a13.635,13.635,0,0,1,12.543-7.856,13.636,13.636,0,0,1,12.544,7.856" transform="translate(206.746 1392.095)" fill="none" stroke="#029c27" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.5" />
                                    </g>
                                </svg>,
  },
  {
    label: "Points Book",
    path: "/points-book",
    icon: (<svg xmlns="http://www.w3.org/2000/svg" className="nav-icon" width="15" height="15" viewBox="0 0 36.012 36.012">
                                    <g id="Points_Book" data-name="Points Book" transform="translate(-206.746 -1043.49)">
                                        <path id="Path_676" data-name="Path 676" d="M33.844,162.716H2.168A2.168,2.168,0,0,1,0,160.548V128.872a2.168,2.168,0,0,1,4.336,0V158.38H33.844a2.168,2.168,0,0,1,0,4.336" transform="translate(206.746 916.786)" fill="#029c27" />
                                        <path id="Path_677" data-name="Path 677" d="M9.207,153.917a2.168,2.168,0,0,1-1.533-3.7l8.8-8.8a2.167,2.167,0,0,1,2.833-.2l4.96,3.72,5.086-10.187a2.168,2.168,0,0,1,3.879,1.937L26.985,149.2a2.168,2.168,0,0,1-3.24.766l-5.535-4.152-7.47,7.47a2.163,2.163,0,0,1-1.533.635" transform="translate(206.746 916.786)" fill="#029c27" />
                                        <path id="Path_678" data-name="Path 678" d="M32.172,136.32H32a2.168,2.168,0,0,1,0-4.336h.176a2.168,2.168,0,0,1,0,4.336" transform="translate(206.746 916.786)" fill="#029c27" />
                                    </g>
                                </svg>),
  },
  {
    label: "Redeem",
    path: "/redeem",
    icon: (<svg xmlns="http://www.w3.org/2000/svg" className="nav-icon" width="15" height="15" viewBox="0 0 32.492 36.014">
                                    <g id="Redeem" transform="translate(-210.266 -1171.954)">
                                        <path id="Path_679" data-name="Path 679" d="M32.436,268.464a8.345,8.345,0,0,1-4.369-1.236c-1.085-.716-4.137-.828-5.877-.691a2.168,2.168,0,0,1-.345-4.322c.968-.077,5.929-.377,8.549,1.356a4.009,4.009,0,0,0,2.965.452,2.168,2.168,0,1,1,.97,4.226,8.469,8.469,0,0,1-1.893.215" transform="translate(206.746 916.786)" fill="#029c27" />
                                        <path id="Path_680" data-name="Path 680" d="M17.7,291.182a27.526,27.526,0,0,1-7.673-1.091,9.21,9.21,0,0,1-6.509-8.8,14.37,14.37,0,0,1,1.494-6.246L10.3,264.48a3.948,3.948,0,0,1,1.247-1.448l-.6-3.226a3.9,3.9,0,0,1,.068-1.721,3.924,3.924,0,0,1,2.173-2.566,3.843,3.843,0,0,1,1.679-.35h6.307a3.926,3.926,0,0,1,3.808,2.92,3.921,3.921,0,0,1,.066,1.716l-.582,3.223a3.939,3.939,0,0,1,1.248,1.444L31,275.038a14.347,14.347,0,0,1,1.5,6.229,9.208,9.208,0,0,1-6.467,8.812,27.348,27.348,0,0,1-8.018,1.1l-.305,0m-3.644-24.533L8.894,276.977a9.979,9.979,0,0,0-1.039,4.33,4.9,4.9,0,0,0,.948,2.867,4.834,4.834,0,0,0,2.475,1.766,23.034,23.034,0,0,0,6.7.9h.051a22.92,22.92,0,0,0,6.744-.918,4.8,4.8,0,0,0,2.433-1.751,4.907,4.907,0,0,0,.948-2.889,9.956,9.956,0,0,0-1.04-4.313l-5.162-10.326Zm-.237,0h0Zm8.38,0h0Zm-6.4-4.44h4.409l.489-2.7H15.3Zm-.957-2.7h0m6.341,0h0Zm-.4-.477v0Z" transform="translate(206.746 916.786)" fill="#029c27" />
                                    </g>
                                </svg>),
  },
  {
    label: "Refer Friend",
    path: "/refer-friend",
    icon: (<svg xmlns="http://www.w3.org/2000/svg" className="nav-icon" width="15" height="15" viewBox="0 0 36.013 36.012">
                                    <g id="Refer_Friend" data-name="Refer Friend" transform="translate(-206.746 -916.786)">
                                        <path id="Path_675" data-name="Path 675" d="M32.083,36.012a2.157,2.157,0,0,1-.969-.23L23.17,31.8a19.507,19.507,0,0,1-5.146.69H18c-9.925,0-18-7.288-18-16.246S8.078,0,18.007,0,36.013,7.288,36.013,16.246a15.271,15.271,0,0,1-3.637,9.811l1.812,7.262a2.169,2.169,0,0,1-2.1,2.693m-8.709-8.7a2.166,2.166,0,0,1,.97.23l4.5,2.252-.952-3.82a2.168,2.168,0,0,1,.569-2.056,10.952,10.952,0,0,0,3.22-7.69c0-6.549-6.133-11.892-13.67-11.892S4.336,9.679,4.336,16.246s6.133,11.91,13.671,11.91h.016a15.148,15.148,0,0,0,4.682-.739,2.194,2.194,0,0,1,.669-.1" transform="translate(206.746 916.786)" fill="#029c27" />
                                    </g>
                                </svg>),
  },
  {
    label: "Ratings",
    path: "/ratings",
    icon: (<svg xmlns="http://www.w3.org/2000/svg" className="nav-icon" width="15" height="25" viewBox="0 0 50.106 28.639">
  <g id="Layer_2" data-name="Layer 2" transform="translate(-2.006 -8)">
    <path id="Path_1923" data-name="Path 1923" d="M29.943,24.764,34.3,21.6a3.388,3.388,0,0,0-1.99-6.13H26.921l-1.665-5.13a3.386,3.386,0,0,0-6.444,0l-1.665,5.124H11.756A3.388,3.388,0,0,0,9.765,21.6l4.362,3.168L12.459,29.9a3.389,3.389,0,0,0,5.214,3.789l4.362-3.179L26.4,33.68a3.388,3.388,0,0,0,5.214-3.789Z" transform="translate(5.019)" fill="#029c27"/>
    <path id="Path_1924" data-name="Path 1924" d="M14.936,21.187,12.681,19.54a6.909,6.909,0,0,1-2.864-5.28L9.155,16.3H4.77a2.762,2.762,0,0,0-1.629,4.994L6.7,23.89l-1.36,4.17a2.753,2.753,0,0,0,4.242,3.1l3.562-2.577,1.718,1.253a7.05,7.05,0,0,1-.788-6Z" transform="translate(0 4.945)" fill="#029c27"/>
    <path id="Path_1925" data-name="Path 1925" d="M35.568,18.216A2.728,2.728,0,0,0,32.937,16.3H28.551l-.662-2.04a6.909,6.909,0,0,1-2.864,5.28L22.77,21.187l.859,2.649a7.05,7.05,0,0,1-.788,6l1.718-1.253,3.562,2.577a2.76,2.76,0,0,0,4.242-3.1L31,23.89l3.562-2.6a2.708,2.708,0,0,0,1-3.079Z" transform="translate(16.402 4.945)" fill="#029c27"/>
  </g>
</svg>),
  },{
    label: "Connections",
    path: "/connections",
    icon: (<svg xmlns="http://www.w3.org/2000/svg" className="nav-icon" width="15" height="15" viewBox="0 0 50.106 55.012">
  <path id="connections" d="M68.018,23.665a4.733,4.733,0,0,0-4.1,2.382L55.032,24.5a7.454,7.454,0,0,0-.606-2.642l3.929-2.824a5.616,5.616,0,1,0-1.882-2.615l-3.93,2.824a7.488,7.488,0,0,0-9.057-.736L33.212,8.236a5.622,5.622,0,1,0-2.278,2.278L41.208,20.787a7.473,7.473,0,0,0-.911,2.03l-1.948-.108a3.719,3.719,0,1,0-.179,3.216l1.948.108a7.482,7.482,0,0,0,1.723,3.691l-8.491,11.3a7.284,7.284,0,1,0,2.574,1.937l8.49-11.3a7.5,7.5,0,0,0,10.066-3.987l8.881,1.544a4.73,4.73,0,1,0,4.657-5.555ZM47.53,29.121a4.289,4.289,0,1,1,4.289-4.289A4.289,4.289,0,0,1,47.53,29.121Z" transform="translate(-22.642 0.056)" fill="#029c27"/>
</svg>),
  }
];

const Sidebar = () => {
  const location = useLocation();

  const [showSidebar, setShowSidebar] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const toggleSidebar = () => setShowSidebar(!showSidebar);
  const closeSidebar = () => setShowSidebar(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/* Mobile Sidebar Toggle */}
      {isMobile && (
        <Col xs={12} className="d-md-none p-2 bg-light shadow-sm">
          <Button variant="outline-secondary" onClick={toggleSidebar}>
            ☰ Menu
          </Button>
        </Col>
      )}

      {/* Sidebar for Desktop */}
      <Col md={2} className="vh-100 d-none d-md-block sidebar" style={{ padding: "0" }}>
        <img src={logo} alt="Torfacts" className="brandlogo" />
        <Card className="text-center points-sec">
          <Card.Body>
            <img src={points} alt="points" className="pointsimg" />
            <Card.Text>Earned points</Card.Text>
            <h2 className="text-success">3000</h2>
          </Card.Body>
        </Card>
        <ListGroup>
          {menuItems.map((item, index) => (
            <ListGroup.Item
              as={Link}
              to={item.path}
              key={index}
              active={location.pathname === item.path}
            >
              {item.icon} {item.label}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Col>

      {/* Sidebar for Mobile */}
      {isMobile && (
        <Offcanvas show={showSidebar} onHide={closeSidebar} placement="start">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Menu</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="text-center mb-3">
              <Image src={logo} height={64} className="mb-2" />
              <div className="text-success">Turning insights into rewards</div>
            </div>
            <Card className="text-center mb-3">
              <Card.Body>
                <div>Earned points</div>
                <h4 className="text-success">3000</h4>
              </Card.Body>
            </Card>
            <ListGroup>
              {menuItems.map((item, index) => (
                <ListGroup.Item
                  as={Link}
                  to={item.path}
                  key={index}
                  onClick={closeSidebar}
                  active={location.pathname === item.path}
                >
                  {item.label}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Offcanvas.Body>
        </Offcanvas>
      )}
    </>
  );
};

export default Sidebar;
